import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2cb502de&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb502de')) {
      api.createRecord('2cb502de', component.options)
    } else {
      api.reload('2cb502de', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2cb502de&", function () {
      api.rerender('2cb502de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/pages/index.vue"
export default component.exports